import { createSelector } from '@reduxjs/toolkit';

import { getEndDate, isLTOperatorSelector } from './package';

import {
  makeTouristSchema,
  makeTouristSchemaHotelCheckout,
  makeTouristsSchema,
} from '../../validators'; // eslint-disable-line
import { getSupplierFieldsData } from '../../CheckoutRoutes/HotelCheckout/store/domains/supplierFields/selectors';

export const getTouristValidationSchema = createSelector(
  [getEndDate, isLTOperatorSelector],
  (tourEndDate, isLevelTravelTourOperator) =>
    makeTouristSchema({
      tourEndDate: new Date(tourEndDate),
      isLevelTravelTourOperator,
    }),
);

export const getTouristValidationSchemaHotelCheckout = createSelector(
  [getSupplierFieldsData],
  (supplierFields) => makeTouristSchemaHotelCheckout(supplierFields[0]),
);

export const getTouristsValidationSchemaHotelCheckout = createSelector(
  getTouristValidationSchemaHotelCheckout,
  (schema) => makeTouristsSchema(schema),
);

export const getTouristsValidationSchema = createSelector(
  getTouristValidationSchema,
  (schema) => makeTouristsSchema(schema),
);
